import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  openValue?: boolean;
  colorValue?: string;
}

export const Root = styled.div`
  display: flex;
  z-index: 2;
  align-items: center;
  justify-content: center;
  padding: 10px 5px 5px 7px;
`;

export const IconContainer = styled.div`
  display: flex;
  cursor: pointer;
  transition: transform 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transform: scale(${(props: IRootProps) => (props.openValue ? `1.05` : `1`)});
  &:hover {
    transform: scale(1.05);
  }
`;

export const ColorIcon = styled.div`
  width: 3px;
  height: 11px;
  border: 2px solid ${(props: IRootProps) => (props.colorValue ?? C.DARK_BLUE)};
`;

export const Container = styled.div`
  position: absolute;
  top: 100px;
  right: 48px;
  width: 282px;
  padding: 19px 16px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border-radius: 3px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16);
  background-color: ${C.WHITE};
`;

export const Title = styled.div`
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.BLACK};
`;

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 0px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #272727;
`;

export const SwitchPadding = styled.div`
  padding: 0px 7px;
`;

export const SubTitle = styled.div`
  margin-top: 30px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #272727;
`;

